export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/60">
      <div className="px-4 md:px-8 max-w-[1280px] mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="text-lg font-heading font-bold text-primary-500">
              天堂影院
            </span>
            <p className="mt-3 text-sm text-foreground-500 leading-relaxed max-w-xs">
              免费在线影视资源平台，提供高清流畅的电影、电视剧、综艺和动漫在线播放服务。无需注册，打开即看。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-800 mb-4">快速导航</h3>
            <ul className="space-y-2.5">
              {[
                { label: '最新动态', href: '#updates' },
                { label: '精选推荐', href: '#cards' },
                { label: '焦点专题', href: '#carousel' },
                { label: '热度排行', href: '#ranking' },
                { label: '常见问答', href: '#faq' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-500 hover:text-primary-400 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-800 mb-4">影视分类</h3>
            <ul className="space-y-2.5">
              {[
                { label: '动作大片', href: '#topics' },
                { label: '科幻巨制', href: '#topics' },
                { label: '悬疑推理', href: '#topics' },
                { label: '日韩剧集', href: '#topics' },
                { label: '纪录纪实', href: '#topics' },
              ].map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-500 hover:text-primary-400 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-800 mb-4">合作伙伴</h3>
            <p className="text-xs text-foreground-400 leading-relaxed">
              合作品牌与平台信息将陆续更新，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/40 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2026 天堂影院 - 免费在线看大片。本站所有内容仅供学习交流，版权归原作者所有。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <a href="#hero" className="hover:text-foreground-600 transition-colors">关于我们</a>
            <a href="#faq" className="hover:text-foreground-600 transition-colors">帮助中心</a>
            <a href="#contact" className="hover:text-foreground-600 transition-colors">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}